import {
  BUILDER_CHOICE_CARD_SELECTED,
  BUILDER_CHOICE_CARD_UNSELECTED,
} from './builderFieldStyles'

export default function ChoiceCard({
  icon,
  title,
  description,
  onClick,
  compact = false,
  centered = false,
  centeredSize = 'lg',
  tooltip,
  selected = false,
  iconAccentBackground = false,
}) {
  const centeredIconWrapClass = iconAccentBackground
    ? selected
      ? 'bg-accent-200 text-primary-700'
      : 'bg-accent-100 text-primary-600'
    : selected
      ? 'bg-primary-100 text-primary-600'
      : 'bg-primary-50 text-primary-600'
  if (compact) {
    return (
      <button
        type="button"
        onClick={onClick}
        title={tooltip}
        aria-pressed={selected}
        className={`w-full rounded-2xl px-3.5 py-3 text-left shadow-sm transition ${
          selected ? BUILDER_CHOICE_CARD_SELECTED : BUILDER_CHOICE_CARD_UNSELECTED
        }`}
      >
        <div className={`flex items-start gap-2.5 ${selected ? 'text-primary-900' : 'text-gray-700'}`}>
          <div
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl [&_svg]:h-4 [&_svg]:w-4 ${
              selected ? 'bg-primary-100 text-primary-600' : 'bg-gray-100 text-gray-600'
            }`}
          >
            {icon}
          </div>
          <div className="min-w-0 flex-1">
            <span
              className={`block text-sm font-semibold leading-snug ${
                selected ? 'text-primary-900' : 'text-gray-900'
              }`}
            >
              {title}
            </span>
            {description ? (
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-gray-500">{description}</p>
            ) : null}
          </div>
        </div>
      </button>
    )
  }

  if (centered) {
    const isMd = centeredSize === 'md'
    return (
      <button
        type="button"
        onClick={onClick}
        title={tooltip}
        aria-pressed={selected}
        className={`flex w-full flex-col items-center justify-center rounded-3xl text-center shadow-sm transition-all duration-200 ease-out ${
          isMd ? 'min-h-[6.75rem] px-5 py-5 sm:min-h-[7.25rem]' : 'min-h-[9.5rem] px-6 py-6'
        } ${selected ? BUILDER_CHOICE_CARD_SELECTED : BUILDER_CHOICE_CARD_UNSELECTED}`}
      >
        <div
          className={`flex items-center justify-center rounded-2xl ${
            isMd ? 'h-10 w-10 [&_svg]:h-5 [&_svg]:w-5' : 'h-11 w-11 [&_svg]:h-5 [&_svg]:w-5'
          } ${centeredIconWrapClass}`}
        >
          {icon}
        </div>
        <span
          className={`font-semibold leading-snug ${
            isMd ? 'mt-2.5 text-base sm:text-lg' : 'mt-3 text-lg'
          } ${selected ? 'text-primary-900' : 'text-gray-900'}`}
        >
          {title}
        </span>
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title={tooltip}
      aria-pressed={selected}
      className={`w-full rounded-3xl px-6 py-6 text-left shadow-sm transition-all ${
        selected ? BUILDER_CHOICE_CARD_SELECTED : BUILDER_CHOICE_CARD_UNSELECTED
      }`}
    >
      <div className={`flex items-center gap-3 ${selected ? 'text-primary-900' : 'text-gray-700'}`}>
        <div
          className={`flex h-10 w-10 items-center justify-center rounded-2xl ${
            selected ? 'bg-primary-100 text-primary-600' : 'bg-gray-100 text-gray-600'
          }`}
        >
          {icon}
        </div>
        <span className={`text-lg font-semibold ${selected ? 'text-primary-900' : 'text-gray-900'}`}>{title}</span>
      </div>
      {description ? <p className="mt-4 text-sm text-gray-500">{description}</p> : null}
    </button>
  )
}
